angular.module('jv.Admin.Users.AddToReqConfig.Factory', [])
    .factory('addToReqModalConfig', [function () {
        return function(postCallback, filterMap) {
            return {
                list: {
                    config: {
                        type: 'multiSelect',
                        keyName: 'selectedReqEId',
                        label: i18n['LIST_MODAL_TEXT'],
                        resetFilterOn: 'modals.addToReq.show',
                        emptySearchText: i18n['FORMTEMPLATE_H_NO_RESULTS_FOUND_PLEASE_DO_ANOTHER_SEARCH'],
                        columns: [
                            {
                                header: i18n['REQUISITION'],
                                show: true,
                                key: ['title'],
                                ellipsis: {
                                    set: true
                                }
                            },
                            {
                                header: i18n['ID'],
                                show: true,
                                key: ['requisitionId']
                            },
                            {
                                header: i18n['STATUS'],
                                show: true,
                                key: ['jobState']
                            },
                            {
                                header: i18n['COMPANY'],
                                show: 'showCompany',
                                key: ['subsidiary.name']
                            },
                            {
                                header: i18n['CATEGORY'],
                                show: true,
                                key: ['category.name'],
                                ellipsis: {
                                    set: true
                                }
                            },
                            {
                                header: i18n['LOCATION'],
                                show: true,
                                key: ['location.name'],
                                ellipsis: {
                                    set: true
                                }
                            }
                        ]
                    },
                    get: {
                        url: '/jhire/action/requisitions?',
                        params: {
                            page: '0',
                            q: '',
                            maxResults: '10',
                            mine: false
                        },
                        responseKey: 'jobs',
                        filterResultsBy: {
                            list: [],
                            filterKey: 'EId'
                        }
                    },
                    post: {
                        callBack: postCallback,
                        button: {
                            label: i18n['ADD'],
                            type: 'button',
                            classNames: ['blue-btn', 'float-right'],
                            id: 'addToReq-btn'
                        }
                    },
                    filters: [
                        {
                            label: i18n['STATUS'],
                            ghostText: i18n['ALL'],
                            allowClear: true,
                            width: 'w175',
                            data: filterMap.statusFilter,
                            keyName: 'reqsStatusFilter',
                            defaultTo:  (filterMap.defaultStatusFilterOption || '{"key":"1","value":"Open"}')
                        },
                        {
                            label: i18n['CATEGORY'],
                            ghostText: i18n['ALL'],
                            allowClear: true,
                            width: 'w260',
                            data: filterMap.categoryFilter,
                            keyName: 'reqsCategoryFilter',
                        }
                    ],
                    search : {
                        label: i18n['SEARCH'],
                        placeholder: i18n['FORMTEMPLATE_H_SEARCH_BY_REQUISITION_OR_ID'],
                        get: {
                            url: '/jhire/action/requisitions?'
                        }
                    }
                }
            };
        };
    }]);